import { Application, ApplicationQuestionGroup } from '@bybeam/platform-types';
import { isQuestionGroupEnabled } from '@platform-ui/utilities/application/question.js';
import { Fragment } from 'react';
import ApplicationQuestionGroupReview from './ApplicationQuestionGroupReview.js';

interface ApplicationQuestionGroupReviewProps {
  application: Application;
  applicationQuestionGroupList: ApplicationQuestionGroup[];
  sectionTitle: string;
}

export default function ApplicationQuestionGroupListReview({
  application,
  applicationQuestionGroupList,
  sectionTitle,
}: ApplicationQuestionGroupReviewProps): JSX.Element {
  // Business logic show the title only if there is more than one group
  const hasMoreThanOneQuestionGroup = applicationQuestionGroupList.length > 1;

  const enabledApplicationQuestionGroups = applicationQuestionGroupList.filter(
    (applicationQuestionGroup) =>
      isQuestionGroupEnabled(applicationQuestionGroup, application.answers),
  );

  return (
    <>
      {enabledApplicationQuestionGroups.map((applicationQuestionGroup, index) => {
        const showSeparator =
          hasMoreThanOneQuestionGroup && index + 1 < applicationQuestionGroupList.length;

        return (
          <Fragment key={applicationQuestionGroup.key}>
            <ApplicationQuestionGroupReview
              application={application}
              applicationQuestionGroup={applicationQuestionGroup}
              sectionTitle={sectionTitle}
            />
            {showSeparator && <div className="w-full border-t border-inputBorder my-4" />}
          </Fragment>
        );
      })}
    </>
  );
}
